import * as tslib_1 from "tslib";
import { EntityNode } from "./EntityNode";
/**
 * SkyboxNode is a space partitioning leaf node that contains a Skybox object.
 *
 * @class away.partition.SkyboxNode
 */
var SkyboxNode = (function (_super) {
    tslib_1.__extends(SkyboxNode, _super);
    function SkyboxNode() {
        return _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    SkyboxNode.prototype.isInFrustum = function (planes, numPlanes) {
        if (!this._entity._iIsVisible)
            return false;
        //a skybox is always in view unless its visibility is set to false
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    SkyboxNode.prototype.isCastingShadow = function () {
        return false; //skybox never casts shadows
    };
    return SkyboxNode;
}(EntityNode));
export { SkyboxNode };



// WEBPACK FOOTER //
// ../dist/lib/partition/SkyboxNode.js